import { useMutation } from "@apollo/client";

import { ProjectReviewVisitV2Screen_UpdateWorkerReportDocument } from "../../../mutations.generated";
import { WorkerReportFormValues } from "../components/WorkerReport";

export function useProjectReviewVisitV2TeamReportsRoute_UpdateWorkerReport() {
    const [mutate, { loading, error }] = useMutation(ProjectReviewVisitV2Screen_UpdateWorkerReportDocument);

    const updateWorkerReport = (plannerVisitWorkerReportId: string, input: WorkerReportFormValues) => {
        mutate({ variables: { input: { ...input, plannerVisitWorkerReportId } } });
    };

    return {
        updateWorkerReport,
        loading,
        error,
    };
}
